import React from "react" ;
import { ReactNode } from "react" ;
import ObservableState from "../utils/ObservableState" ;
import * as ui from "../native" ;
import ObservableComponent from "./ObservableComponent" ;
import BaseUIProps , { copyBaseUIProps } from "../native/ui/BaseUIProps" ;
import ObjectObservable from "../utils/ObjectObservable" ;
import CallData from "../classes/CallData" ;
import Popup from "./Popup" ;
import MaterialIcons from "../icons/MaterialIcons" ;
import User from "../models/User" ;
import DialPadButton from "./DialPadButton" ;
import CallInteraction from "../classes/CallInteraction" ;
import IconButton from "./IconButton" ;
import LeadAssignPopupView from "./LeadAssignPopupView" ;
import Query from "../classes/Query" ;
import MessageDispatch from "../rocket/MessageDispatch" ;
import CallStatus from "../classes/CallStatus" ;
import Button from "./Button" ;
import ContactsView from "./ContactsView" ;
import TwilioClient from "../classes/TwilioClient" ;
import Duration from "../core/Duration" ;
import TextView from "./TextView" ;
import FailureMessage from "../classes/FailureMessage" ;
import PopupTargetController from "./PopupTargetController" ;
import D3EDisposable from "../rocket/D3EDisposable" ;
import SuccessMessage from "../classes/SuccessMessage" ;
import EventBus from "../utils/EventBus" ;
import Timer from "../utils/Timer" ;
import DateTime from "../core/DateTime" ;
import Interaction from "../models/Interaction" ;
import RPCServices from "../rpc/RPCServices" ;
import IconView from "./IconView" ;
import { UsageConstants } from "../rocket/D3ETemplate" ;
import { BuildContext } from "../classes/BuildContext" ;
import ToolTipWrapper from "./ToolTipWrapper" ;

type _CallProgressViewOnCloseView = ( ) => void ;

type _CallProgressViewOnMinimizeView = ( ) => void ;

type _AssignToLeadButtonOnPressed = ( d3eState : CallProgressViewRefs ) => void ;


  export  interface  CallProgressViewProps extends  BaseUIProps {   key?: string ;
   client?: TwilioClient ;
   callInteraction?: CallInteraction ;
   interaction: Interaction ;
   user: User ;
   onCloseView: _CallProgressViewOnCloseView ;
   onMinimizeView?: _CallProgressViewOnMinimizeView ;
 }
/// To store state data for CallProgressView 
   class  CallProgressViewRefs {  public assignToLeadButton: AssignToLeadButtonState = new AssignToLeadButtonState() ;
 }

   interface  AssignToLeadButtonWithStateProps extends  BaseUIProps {   key?: string ;
   d3eState: CallProgressViewRefs ;
   _onAssignToLeadPressed?: _AssignToLeadButtonOnPressed ;
 }

   class  AssignToLeadButtonState extends  ObjectObservable {  private _disable: boolean = false ;
  public _hover: boolean = false ;
  public get disable (  ) : boolean {
 return this._disable ; 
 }
  public setDisable ( val : boolean ) {
 let isValChanged :boolean=this._disable !== val;

if ( !isValChanged ) {
 return ; 
 }

this._disable=val;

this.fire('disable',this);
 }
  public get hover (  ) : boolean {
 return this._hover ; 
 }
  public setHover ( val : boolean ) {
 let isValChanged :boolean=this._hover !== val;

if ( !isValChanged ) {
 return ; 
 }

this._hover=val;

this.fire('hover',this);
 }
 }

   class  _AssignToLeadButtonWithState extends  ObservableComponent<AssignToLeadButtonWithStateProps> {   assignToLeadButtonFocusNode: ui.FocusNode = new ui.FocusNode() ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
 public constructor ( props : AssignToLeadButtonWithStateProps ) {
 super(props);

this.initState();
 }
  public get assignToLeadButton (  ) : AssignToLeadButtonState {
 return this.props.d3eState.assignToLeadButton ; 
 }
  public get d3eState (  ) : CallProgressViewRefs {
 return this.props.d3eState ; 
 }
  public get _onAssignToLeadPressed (  ) : _AssignToLeadButtonOnPressed {
 return this.props._onAssignToLeadPressed ; 
 }
  public initState (  ) {
 super.initState();

this.updateObservable('assignToLeadButton',null,this.assignToLeadButton);

this.initListeners();

this.enableBuild=true;
 }
  public initListeners (  ) : void {
 this.on([ 'assignToLeadButton', 'assignToLeadButton.Button', 'assignToLeadButton.hover' ],this.rebuild);
 }
  public assignToLeadButtonOnEnter ( event ) : void {
 return this.assignToLeadButton.setHover(true) ; 
 }
  public assignToLeadButtonOnExit ( event ) : void {
 return this.assignToLeadButton.setHover(false) ; 
 }
  public dispose (  ) : void {
 this.assignToLeadButton.setHover(false);

super.dispose();
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Container({ margin:ui.EdgeInsets.fromLTRB(5.0,0.0,0.0,0.0,new Map()), child:Button({ disable:this.assignToLeadButton.disable, onPressed:(  ) => {
 this._onAssignToLeadPressed(this.d3eState);
 }
, onFocusChange:( val ) => {
  }
, child:TextView({ data:'Assign to Lead', style:new ui.TextStyle({color:cStyle.c1}), className:'x81' }), onEnter:( event ) => {
 this.assignToLeadButtonOnEnter(event);
 }
, onExit:( event ) => {
 this.assignToLeadButtonOnExit(event);
 }
 }), className:'LinkButton x0d5' }) ; 
 }
 }
function AssignToLeadButtonWithState ( props : AssignToLeadButtonWithStateProps ) {
 return React.createElement(_AssignToLeadButtonWithState,props) ; 
 }


   class  _CallProgressViewState extends  ObservableComponent<CallProgressViewProps> {   static defaultProps = { client:null, callInteraction:null, interaction:null, user:null, onCloseView:null, onMinimizeView:null } ;
   d3eState: CallProgressViewRefs = new CallProgressViewRefs() ;
   isMute: boolean = false ;
   callDuration: string = '' ;
   data: CallData = null ;
   status: CallStatus = CallStatus.Initiated ;
   durationStart: boolean = false ;
   focusNode: ui.FocusNode = null ;
   internalNumber: string = '' ;
   enableNumberPad: boolean = false ;
   digit1: boolean = false ;
   digit2: boolean = false ;
   digit3: boolean = false ;
   digit4: boolean = false ;
   digit5: boolean = false ;
   digit6: boolean = false ;
   digit7: boolean = false ;
   digit8: boolean = false ;
   digit9: boolean = false ;
   digit0: boolean = false ;
   plush: boolean = false ;
   hash: boolean = false ;
   leadAssignPopupPopup: Popup ;
   contactsViewPopup: Popup ;
   static contextType = BuildContext ;
   context: React.ContextType<typeof BuildContext> ;
  public addParticipantPopupTargetController: PopupTargetController = new PopupTargetController() ;
  public interactionDisposable: D3EDisposable ;
  public userDisposable: D3EDisposable ;
 public constructor ( props : CallProgressViewProps ) {
 super(props);

this.initState();
 }
  public get client (  ) : TwilioClient {
 return this.props.client ; 
 }
  public get callInteraction (  ) : CallInteraction {
 return this.props.callInteraction ; 
 }
  public get interaction (  ) : Interaction {
 return this.props.interaction ; 
 }
  public get user (  ) : User {
 return this.props.user ; 
 }
  public initState (  ) {
 super.initState();

this.interactionDisposable=MessageDispatch.get().syncObject(this.props.interaction,UsageConstants.SUBSCRIPTION_ONINTERACTIONCHANGE_CALLPROGRESSVIEW_INTERACTION_SYNCHRONISE);

this.userDisposable=MessageDispatch.get().syncObject(this.props.user,UsageConstants.SUBSCRIPTION_ONUSERCHANGE_CALLPROGRESSVIEW_USER_SYNCHRONISE);

this.runFetchDataQueryForInteraction();

this.interactionDisposable=MessageDispatch.get().syncObject(this.props.interaction,UsageConstants.QUERY_GETINTERACTIONBYID_CALLPROGRESSVIEW_INTERACTION_FETCHDATA);

this.runFetchDataQueryForUser();

this.userDisposable=MessageDispatch.get().syncObject(this.props.user,UsageConstants.QUERY_GETUSERBYID_CALLPROGRESSVIEW_USER_FETCHDATA);

this.initListeners();

this.enableBuild=true;

this.onInit();
 }
  public initListeners (  ) : void {
 this.updateSyncProperty('callInteraction',this.props.callInteraction);

this.updateSyncProperty('interaction',this.props.interaction);

this.on([ 'callInteraction', 'callInteraction.data' ],this.computeData);

this.computeData();

this.on([ 'callInteraction', 'callInteraction.data', 'callInteraction.data.callStatus' ],this.computeStatus);

this.computeStatus();

this.updateSyncProperty('user',this.props.user);

this.on([ 'callDuration', 'callInteraction', 'callInteraction.lead', 'callInteraction.lead.name', 'client', 'digit0', 'digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6', 'digit7', 'digit8', 'digit9', 'enableNumberPad', 'hash', 'interaction', 'interaction.callStatus', 'interaction.isConference', 'internalNumber', 'plush' ],this.rebuild);
 }
  public componentDidUpdate ( prevProps : CallProgressViewProps ) : void {
 super.componentDidUpdate(prevProps);

if ( prevProps.client !== this.props.client ) {
 this.fire('client',this);
 }

if ( prevProps.callInteraction !== this.props.callInteraction ) {
 this.updateObservable('callInteraction',prevProps.callInteraction,this.props.callInteraction);

this.fire('callInteraction',this);
 }

if ( prevProps.interaction !== this.props.interaction ) {
 this.updateObservable('interaction',prevProps.interaction,this.props.interaction);

this.runFetchDataQueryForInteraction();

this.fire('interaction',this);
 }

if ( prevProps.user !== this.props.user ) {
 this.updateObservable('user',prevProps.user,this.props.user);

this.runFetchDataQueryForUser();

this.fire('user',this);
 }
 }
  public runFetchDataQueryForInteraction  =  (  ) : void  =>  {
 if ( this.interaction == null ) {
 return ; 
 }

Query.get().getInteractionById(UsageConstants.QUERY_GETINTERACTIONBYID_CALLPROGRESSVIEW_INTERACTION_FETCHDATA,this.interaction.id);
 }
  public setIsMute ( val : boolean ) : void {
 let isValChanged :boolean=this.isMute !== val;

if ( !isValChanged ) {
 return ; 
 }

this.isMute=val;

this.fire('isMute',this);
 }
  public setCallDuration ( val : string ) : void {
 let isValChanged :boolean=this.callDuration !== val;

if ( !isValChanged ) {
 return ; 
 }

this.callDuration=val;

this.fire('callDuration',this);
 }
  public setData ( val : CallData ) : void {
 let isValChanged :boolean=this.data !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateObservable('data',this.data,val);

this.data=val;

this.fire('data',this);
 }
  public computeData  =  (  ) : void  =>  {
 try {
 this.setData(this.callInteraction.data);
 }
 catch ( exception ) {
 console.log(' exception in computeData : ' + exception.toString());

this.setData(null);
 }
 }
  public setStatus ( val : CallStatus ) : void {
 let isValChanged :boolean=this.status !== val;

if ( !isValChanged ) {
 return ; 
 }

this.status=val;

this.onChangeCallId();

this.fire('status',this);
 }
  public computeStatus  =  (  ) : void  =>  {
 try {
 this.setStatus(this.callInteraction.data.callStatus);
 }
 catch ( exception ) {
 console.log(' exception in computeStatus : ' + exception.toString());

this.setStatus(CallStatus.Initiated);
 }
 }
  public setDurationStart ( val : boolean ) : void {
 let isValChanged :boolean=this.durationStart !== val;

if ( !isValChanged ) {
 return ; 
 }

this.durationStart=val;

this.fire('durationStart',this);
 }
  public runFetchDataQueryForUser  =  (  ) : void  =>  {
 if ( this.user == null ) {
 return ; 
 }

Query.get().getUserById(UsageConstants.QUERY_GETUSERBYID_CALLPROGRESSVIEW_USER_FETCHDATA,this.user.id);
 }
  public setFocusNode ( val : ui.FocusNode ) : void {
 let isValChanged :boolean=this.focusNode !== val;

if ( !isValChanged ) {
 return ; 
 }

this.focusNode=val;

this.fire('focusNode',this);
 }
  public setInternalNumber ( val : string ) : void {
 let isValChanged :boolean=this.internalNumber !== val;

if ( !isValChanged ) {
 return ; 
 }

this.internalNumber=val;

this.fire('internalNumber',this);
 }
  public setEnableNumberPad ( val : boolean ) : void {
 let isValChanged :boolean=this.enableNumberPad !== val;

if ( !isValChanged ) {
 return ; 
 }

this.enableNumberPad=val;

this.fire('enableNumberPad',this);
 }
  public setDigit1 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit1 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit1=val;

this.fire('digit1',this);
 }
  public setDigit2 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit2 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit2=val;

this.fire('digit2',this);
 }
  public setDigit3 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit3 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit3=val;

this.fire('digit3',this);
 }
  public setDigit4 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit4 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit4=val;

this.fire('digit4',this);
 }
  public setDigit5 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit5 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit5=val;

this.fire('digit5',this);
 }
  public setDigit6 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit6 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit6=val;

this.fire('digit6',this);
 }
  public setDigit7 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit7 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit7=val;

this.fire('digit7',this);
 }
  public setDigit8 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit8 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit8=val;

this.fire('digit8',this);
 }
  public setDigit9 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit9 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit9=val;

this.fire('digit9',this);
 }
  public setDigit0 ( val : boolean ) : void {
 let isValChanged :boolean=this.digit0 !== val;

if ( !isValChanged ) {
 return ; 
 }

this.digit0=val;

this.fire('digit0',this);
 }
  public setPlush ( val : boolean ) : void {
 let isValChanged :boolean=this.plush !== val;

if ( !isValChanged ) {
 return ; 
 }

this.plush=val;

this.fire('plush',this);
 }
  public setHash ( val : boolean ) : void {
 let isValChanged :boolean=this.hash !== val;

if ( !isValChanged ) {
 return ; 
 }

this.hash=val;

this.fire('hash',this);
 }
  public render (  ) : ReactNode {
 let cStyle=this.context.theme;

return ui.Column({ children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.spaceBetween, children:[ ui.Row({ children:[ TextView({ data:this.interaction.isConference ? 'Conference Call' : this.callInteraction.lead === null ? 'Unknown Caller' : this.callInteraction.lead.name, style:new ui.TextStyle({fontSize:16,color:cStyle.c14,fontWeight:ui.FontWeight.bold}), className:'x0a3', key:'0' }), TextView({ data:this.callDuration, style:new ui.TextStyle({fontWeight:ui.FontWeight.w400,color:cStyle.c14}), className:'xc02', key:'1' }), ((this.callInteraction.lead === null) ? AssignToLeadButtonWithState({ d3eState:this.d3eState, _onAssignToLeadPressed:this.onAssignToLeadPressed }) : [  ]) ], className:'xab1', key:'0' }), ui.Container({ className:'x82 hc', key:'1' }), IconButton({ icon:MaterialIcons.group_add, color:cStyle.c14, onPressed:(  ) => {
 this.onConferenceCallPressed(this.d3eState);
 }
, d3eRef:this.addParticipantPopupTargetController.handleRef, key:'2' }), IconButton({ icon:MaterialIcons.minimize, color:cStyle.c14, onPressed:(  ) => {
 this.onMinimizePressed(this.d3eState);
 }
, key:'3' }) ], className:'x7e8 hc h', key:'0' }), ui.Row({ children:[ ui.Container({ className:'x8ce5 hc vc h', key:'0' }) ], className:'x0d6 hc h', key:'1' }), ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.center, children:[ ((!this.enableNumberPad) ? ui.Container({ alignment:ui.Alignment.center, child:ui.Container({ alignment:ui.Alignment.center, child:ui.Center({ child:TextView({ data:this.callInteraction.lead === null || this.callInteraction.lead.name === null || (this.callInteraction.lead.name.trim().length < 1) ? 'UN' : this.callInteraction.lead.name [ 0 ] + this.callInteraction.lead.name [ 1 ], textAlign:ui.TextAlign.center, style:new ui.TextStyle({color:new ui.Color(0xff4caca4),fontWeight:ui.FontWeight.bold,fontSize:35}), className:'x95f hc vc' }), className:'hc vc' }), className:'x99b hc vc' }), className:'xe8 hc vc' }) : [  ]), ((!this.enableNumberPad) ? TextView({ data:this.interaction === null ? 'Initiating...' : this.interaction.callStatus === CallStatus.Unanswered ? 'Incoming Call' : this.interaction.callStatus.name, states:ui.joinStates({ 'data-c0':this.interaction === null },{}), style:new ui.TextStyle({color:this.interaction === null ? cStyle.c1 : cStyle.c14}), className:'xe4 hc' }) : [  ]), ((this.enableNumberPad) ? TextView({ data:this.internalNumber, style:new ui.TextStyle({color:cStyle.c14}), className:'xa3 hc' }) : [  ]), ((this.enableNumberPad) ? ui.Column({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ DialPadButton({ digit:'1', isSelected:this.digit1, onTap:(  ) => {
 this.firstButtonHandler(this.d3eState);
 }
, key:'0' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:20.0,vertical:0.0,transitions:new Map()}), child:DialPadButton({ digit:'2', isSelected:this.digit2, onTap:(  ) => {
 this.secoundButtonHandler(this.d3eState);
 }
 }), key:'1', className:'x02' }), DialPadButton({ digit:'3', isSelected:this.digit3, onTap:(  ) => {
 this.button3Handler(this.d3eState);
 }
, key:'2' }) ], className:'x3fb hc h', key:'0' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ DialPadButton({ digit:'4', isSelected:this.digit4, onTap:(  ) => {
 this.button4Handler(this.d3eState);
 }
, key:'0' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:20.0,vertical:0.0,transitions:new Map()}), child:DialPadButton({ digit:'5', isSelected:this.digit5, onTap:(  ) => {
 this.button5Handler(this.d3eState);
 }
 }), key:'1', className:'x86' }), DialPadButton({ digit:'6', isSelected:this.digit6, onTap:(  ) => {
 this.button6Handler(this.d3eState);
 }
, key:'2' }) ], className:'xaec hc h', key:'1' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ DialPadButton({ digit:'7', isSelected:this.digit7, onTap:(  ) => {
 this.button7Handler(this.d3eState);
 }
, key:'0' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:20.0,vertical:0.0,transitions:new Map()}), child:DialPadButton({ digit:'8', isSelected:this.digit8, onTap:(  ) => {
 this.button8Handler(this.d3eState);
 }
 }), key:'1', className:'x3f5' }), DialPadButton({ digit:'9', isSelected:this.digit9, onTap:(  ) => {
 this.button9Handler(this.d3eState);
 }
, key:'2' }) ], className:'x095 hc h', key:'2' }), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, crossAxisAlignment:ui.CrossAxisAlignment.center, children:[ DialPadButton({ digit:'+', isSelected:this.plush, onTap:(  ) => {
 this.buttonStarHandler(this.d3eState);
 }
, key:'0' }), ui.Container({ margin:ui.EdgeInsets.symmetric({horizontal:20.0,vertical:0.0,transitions:new Map()}), child:DialPadButton({ digit:'0', isSelected:this.digit0, onTap:(  ) => {
 this.button0Handler(this.d3eState);
 }
 }), key:'1', className:'xf0b' }), DialPadButton({ digit:'#', isSelected:this.hash, onTap:(  ) => {
 this.buttonHashHandler(this.d3eState);
 }
, key:'2' }) ], className:'x5b2 hc h', key:'3' }) ], className:'x44a hc h' }) : [  ]), ui.Row({ mainAxisAlignment:ui.MainAxisAlignment.center, children:[ ui.Container({ alignment:ui.Alignment.center, child:ToolTipWrapper({message:'DailPad',backgroundColor:cStyle.tooltipBackgroundColor,textColor:cStyle.tooltipTextColor,child:IconView({ icon:!this.enableNumberPad ? MaterialIcons.dialpad : MaterialIcons.dialpad, color:cStyle.c14, className:'x270 hc vc' })}), onTap:( e ) => {
 e.stopPropagation();

this.onDialPadPressed(this.d3eState);
 }
, className:'x2a9 hc vc', key:'0' }), ui.Container({ className:'xffc hc', key:'1' }), ui.Container({ alignment:ui.Alignment.center, child:ToolTipWrapper({message:'Mute',backgroundColor:cStyle.tooltipBackgroundColor,textColor:cStyle.tooltipTextColor,child:IconView({ icon:this.client.isMuted ? MaterialIcons.mic_off : MaterialIcons.mic, color:cStyle.c14, className:'x676 hc vc' })}), onTap:( e ) => {
 e.stopPropagation();

this.onVoiceMutePressed(this.d3eState);
 }
, className:'x6a3 hc vc', key:'2' }), ui.Container({ className:'x0f hc', key:'3' }), ui.Container({ alignment:ui.Alignment.center, child:ToolTipWrapper({message:'Hangup',backgroundColor:cStyle.tooltipBackgroundColor,textColor:cStyle.tooltipTextColor,child:IconView({ icon:MaterialIcons.call_end, color:cStyle.c14, className:'x9ac hc vc' })}), onTap:( e ) => {
 e.stopPropagation();

this.onDisconnectPressed(this.d3eState);
 }
, className:'xcab hc vc', key:'4' }) ], className:'x318 hc h', key:'4' }) ], className:'x17f hc vc h', key:'2' }) ], className:ui.join('CallProgressView xff6 hc vc ' , this.props.className ?? ''), ...copyBaseUIProps(this.props,) }) ; 
 }
  public onInit  =  (  ) : void  =>  {
 this.setCallDuration('');

this.setDurationStart(false);
 }
  public onDialPadPressed  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setEnableNumberPad(!this.enableNumberPad);
 }
  public onVoiceMutePressed  =  async  ( d3eState : CallProgressViewRefs ) : Promise<void>  =>  {
 if ( this.client.isMuted ) {
 let unmute :boolean=( await this.client.unmuteCall({ onSuccess:( e ) => {
 this.setIsMute(false);
 }
, onFailure:( e,s ) => {
 EventBus.get().fire(new FailureMessage({ message:e }));
 }
 }));
 }
 else {
 let mute :boolean=( await this.client.muteCall({ onSuccess:( e ) => {
 this.setIsMute(true);
 }
, onFailure:( e,s ) => {
 EventBus.get().fire(new FailureMessage({ message:e }));
 }
 }));
 }
 }
  public onDisconnectPressed  =  async  ( d3eState : CallProgressViewRefs ) : Promise<void>  =>  {
 let disconnect :boolean=( await this.client.disconnectCall({ onFailure:( e ) => {
 this.onCallDisconnectError(e);
 }
 }));

this.onCloseView();
 }
  public onChangeCallId  =  (  ) : void  =>  {
 if ( this.data !== null && (this.data.callSid === null || this.data.callSid.isEmpty) ) {
 if ( this.data.callStatus === CallStatus.Closed || this.data.callStatus === CallStatus.Completed || this.data.callStatus === CallStatus.Completed || this.data.callStatus === CallStatus.Failed || this.data.callStatus === CallStatus.Busy || this.data.callStatus === CallStatus.Unanswered ) {
 this.onCloseView();
 }
 }

if ( this.data !== null && this.data.callStatus === CallStatus.InProgress && !this.durationStart ) {
 this.setDurationStart(true);

if ( this.callInteraction.interaction.startTime === null ) {
 this.callInteraction.interaction.setStartTime(DateTime.now());
 }

let startTime :DateTime=this.callInteraction.interaction.startTime;

let tmr :Timer=Timer.periodic(new Duration({ seconds:1 }),( timer ) => {
 //  Calculate the duration

let duration :Duration=DateTime.now().difference(startTime);

let totalInSeconds :number=duration.inSeconds.toDouble();

//  Calculate hours, minutes, and seconds

let hours :number=(totalInSeconds / 3600);

hours=hours.floorToDouble();

let minutes :number=(totalInSeconds / 60);

minutes=minutes.floorToDouble();

let seconds :number=totalInSeconds % 60;

//  Convert minutes and seconds to strings

let minutesStr :string=minutes.toStringAsFixed(0);

let secondsStr :string=seconds.toStringAsFixed(0);

//  Manually add leading zero if needed

if ( minutesStr.length === 1 ) {
 minutesStr='0' + minutesStr;
 }

if ( secondsStr.length === 1 ) {
 secondsStr='0' + secondsStr;
 }

//  Format the call duration string

if ( hours >= 1.0 ) {
 //  Show hours if the duration is 1 hour or more

this.setCallDuration(hours.toString() + ':' + minutesStr + ':' + secondsStr);
 }
 else {
 //  Show only minutes and seconds

this.setCallDuration(minutesStr + ':' + secondsStr);
 }
 }
);
 }
 }
  public onCallDisconnectError  =  ( error : string ) : void  =>  {
 EventBus.get().fire(new FailureMessage({ message:error }));
 }
  public onMinimizePressed  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.onMinimizeView();
 }
  public onAssignToLeadPressed  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.showLeadAssignPopup();
 }
  public onAddParticipantPressed  =  async  ( numberValue : string ) : Promise<void>  =>  {
 let enteredNumber :string=TwilioClient.getPurifiedPhoneNumber(numberValue);

this.hideContactsView();

if ( this.interaction !== null && !this.interaction.isConference ) {
 let isConference :boolean=( await RPCServices.getCallService().convertToConference(this.data.callSid,this.interaction.fromNumber,this.interaction.toNumber,enteredNumber));

if ( isConference ) {
 this.interaction.setIsConference(true);

this.interaction.participants.add(this.interaction.toNumber);

this.interaction.participants.add(enteredNumber);

EventBus.get().fire(new SuccessMessage({ message:'Participant Added' }));
 }
 }
 else {
 let add :boolean=( await RPCServices.getCallService().addParticipant(this.interaction.fromNumber,this.interaction.toNumber,enteredNumber,(this.interaction.isIncoming ? this.interaction.toNumber : this.interaction.fromNumber)));

if ( add ) {
 this.interaction.participants.add(enteredNumber);

EventBus.get().fire(new SuccessMessage({ message:'Participant Added' }));
 }
 }
 }
  public onConferenceCallPressed  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.showContactsView();
 }
  public firstButtonHandler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '1');

this.client.sendDigit('1');
 }
  public secoundButtonHandler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '2');

this.client.sendDigit('2');
 }
  public button3Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '3');

this.client.sendDigit('3');
 }
  public button4Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '4');

this.client.sendDigit('4');
 }
  public button5Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '5');

this.client.sendDigit('5');
 }
  public button6Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '6');

this.client.sendDigit('6');
 }
  public button7Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '7');

this.client.sendDigit('7');
 }
  public button8Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '8');

this.client.sendDigit('8');
 }
  public button9Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '9');

this.client.sendDigit('9');
 }
  public buttonStarHandler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '+');
 }
  public button0Handler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '0');

this.client.sendDigit('0');
 }
  public buttonHashHandler  =  ( d3eState : CallProgressViewRefs ) : void  =>  {
 this.setInternalNumber(this.internalNumber + '#');

this.client.sendDigit('#');
 }
  public get onCloseView (  ) : _CallProgressViewOnCloseView {
 return this.props.onCloseView ; 
 }
  public get onMinimizeView (  ) : _CallProgressViewOnMinimizeView {
 return this.props.onMinimizeView ; 
 }
  public dispose (  ) : void {
 this.interactionDisposable?.dispose();

this.userDisposable?.dispose();

MessageDispatch.get().dispose(this.callInteraction);

this.leadAssignPopupPopup?.dispose();

this.contactsViewPopup?.dispose();

super.dispose();
 }
  public showLeadAssignPopup ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.leadAssignPopupPopup ?. dispose();

this.leadAssignPopupPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Center,child:LeadAssignPopupView({ interaction:this.callInteraction.interaction, className:'hc vc' })});

this.leadAssignPopupPopup.showPopup(this.context);
 }
  public showContactsView ( d3eParams ? : Partial<{autoClose: boolean, model: boolean, float: boolean, takeFocus: boolean}> ) : void {
 let autoClose=d3eParams?.autoClose;

let model=d3eParams?.model;

let float=d3eParams?.float;

let takeFocus=d3eParams?.takeFocus;

this.contactsViewPopup ?. dispose();

let target :ui.Rect=this.addParticipantPopupTargetController.getTarget(this.context);

this.contactsViewPopup=new Popup({autoClose:autoClose,model:model,float:float,takeFocus:takeFocus,position:ui.PopUpPosition.Top,child:ui.Container({ width:320, child:ContactsView({ reportingManager:this.user.reportingManager, onAddButtonPressed:( number ) => {
 this.onAddParticipantPressed(number);
 }
 }), className:'xc25 hc vc' }),target:target});

this.contactsViewPopup.showPopup(this.context);
 }
  public hideLeadAssignPopup (  ) : void {
 this.leadAssignPopupPopup ?. dispose();
 }
  public hideContactsView (  ) : void {
 this.contactsViewPopup ?. dispose();
 }
  public get assignToLeadButton (  ) {
 return this.d3eState.assignToLeadButton ; 
 }
 }
export default function CallProgressView ( props : CallProgressViewProps ) {
 return React.createElement(_CallProgressViewState,{ ..._CallProgressViewState.defaultProps, ...props }) ; 
 }
